import {Loader} from "@googlemaps/js-api-loader";
import {initializeGoogleMap} from "./google-maps-core.js";

const googleMapContainer = document.getElementById("googleMapContainer");

const loader = new Loader({
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  version: "weekly",
});

let googleMapControls;
let isLoadingGoogleMaps = false;

const handleInitMap = async () => {
  if (!googleMapContainer || googleMapControls || isLoadingGoogleMaps) return;

  isLoadingGoogleMaps = true;

  try {
    const {loaded, map} = await initializeGoogleMap({
      googleMapContainer,
      loader,
      getGoogleMaps: () => globalThis.google?.maps,
    });

    if (loaded) googleMapControls = map;
  } finally {
    isLoadingGoogleMaps = false;
  }
};

if (googleMapContainer) handleInitMap();
